var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeRejectedVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0337 14.431C18.0521 14.1062 18.0012 13.7734 17.8736 13.4546L16.987 11.238C16.6073 10.2889 15.6881 9.6665 14.6658 9.6665H12.2648C11.5757 9.6665 10.9149 9.94022 10.4277 10.4275C9.94047 10.9147 9.66675 11.5755 9.66675 12.2645C9.66675 12.2814 9.66726 12.2983 9.66828 12.3151C9.83867 15.1189 10.7939 17.8002 12.4009 20.0637L18.0337 14.431Z",
    fill: "#FF3A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8201 24.0013L9.91083 24.9106C9.58539 25.236 9.58539 25.7637 9.91083 26.0891C10.2363 26.4145 10.7639 26.4145 11.0893 26.0891L14.6255 22.553C17.1277 24.7907 20.3179 26.127 23.6848 26.3316C23.7017 26.3327 23.7185 26.3332 23.7354 26.3332C24.4244 26.3332 25.0852 26.0595 25.5725 25.5722C26.0597 25.085 26.3334 24.4242 26.3334 23.7351V21.3341C26.3334 20.3118 25.711 19.3926 24.7619 19.0129L22.5453 18.1263C21.5042 17.7099 20.3148 18.1105 19.7379 19.0721C19.5547 19.3773 19.2448 19.3984 19.0782 19.2855C18.8441 19.1267 18.6181 18.9572 18.401 18.7774L26.0893 11.0891C26.4148 10.7637 26.4148 10.236 26.0893 9.91058C25.768 9.58927 25.2496 9.5852 24.9233 9.89838L10.8326 23.9891C10.8285 23.9932 10.8243 23.9973 10.8201 24.0013Z",
    fill: "#FF3A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeRejectedVoiceCall);
export default __webpack_public_path__ + "static/media/me-rejected-voice-call.23c51537d8788c7658948954b4b458dd.svg";
export { ForwardRef as ReactComponent };